import React from 'react';

/**
 * Ritaglio statico della lista campagne, con lo stesso vocabolario visivo di
 * NewsletterCampaignListView.tsx (badge Bozza/Programmata/Inviata, tassi di
 * apertura e click). Come WarehousePreview è una `<table>`: la regola globale
 * in index.css (`div[class*="bg-white"] > div[class*="border-b"]`) forza a
 * bianco pieno qualunque div-riga e renderebbe illeggibile l'anteprima.
 */
const DEMO_CAMPAIGNS = [
  { name: 'Offerta primavera', status: 'sent', open: '42,1%', click: '18,4%' },
  { name: 'Novità catalogo', status: 'scheduled', open: '—', click: '—' },
  { name: 'Recupero carrelli', status: 'draft', open: '—', click: '—' },
];

const STATUS_BADGE: Record<string, { label: string; className: string }> = {
  sent: {
    label: 'Inviata',
    className: 'bg-green-100 dark:bg-green-900/30 text-green-600 dark:text-green-400',
  },
  scheduled: {
    label: 'Programmata',
    className: 'bg-blue-100 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400',
  },
  draft: {
    label: 'Bozza',
    className: 'bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-400',
  },
};

export const NewsletterPreview: React.FC = () => (
  <div
    aria-hidden="true"
    className="rounded-lg border border-[rgba(55,53,47,0.09)] dark:border-gray-700 overflow-hidden select-none"
  >
    <table className="w-full border-collapse">
      <thead className="bg-[#FBFBFA] dark:bg-gray-900/40">
        <tr className="border-b border-[rgba(55,53,47,0.09)] dark:border-gray-700">
          <th className="px-3 py-2 text-left text-[10px] font-medium text-[#787774] dark:text-gray-400 uppercase tracking-wider">
            Campagna
          </th>
          <th className="px-3 py-2 text-left text-[10px] font-medium text-[#787774] dark:text-gray-400 uppercase tracking-wider">
            Stato
          </th>
          <th className="px-3 py-2 text-right text-[10px] font-medium text-[#787774] dark:text-gray-400 uppercase tracking-wider">
            Aperture
          </th>
          <th className="px-3 py-2 text-right text-[10px] font-medium text-[#787774] dark:text-gray-400 uppercase tracking-wider">
            Click
          </th>
        </tr>
      </thead>
      <tbody>
        {DEMO_CAMPAIGNS.map((c) => {
          const badge = STATUS_BADGE[c.status];
          return (
            <tr
              key={c.name}
              className="border-b border-[rgba(55,53,47,0.06)] dark:border-gray-700/60 last:border-b-0"
            >
              <td className="px-3 py-2 text-[12px] text-[#37352F] dark:text-gray-200 truncate">
                {c.name}
              </td>
              <td className="px-3 py-2">
                <span
                  className={`inline-flex px-1.5 py-0.5 text-[10px] font-semibold rounded-full ${badge.className}`}
                >
                  {badge.label}
                </span>
              </td>
              <td className="px-3 py-2 text-[12px] text-right font-medium text-[#37352F] dark:text-gray-200">
                {c.open}
              </td>
              <td className="px-3 py-2 text-[12px] text-right font-medium text-[#37352F] dark:text-gray-200">
                {c.click}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  </div>
);
